import { createApi } from '../createApi';
import * as dummy from '../dummy/tours';
import * as real from '../api/tours';

const api = createApi(dummy, real);

/** 투어 서비스 — API_DOCS: 9. 투어 / 23. 관리자 - 투어 */
export const tourService = {
  /* 서비스 (유저용) */
  getList: api.getTours,
  getById: api.getTourById,
  getSchedules: api.getTourSchedules,
  createReservation: api.createTourReservation,

  /* 관리자 */
  adminGetList: api.getAdminTours,
  adminGetById: api.getAdminTourById,
  adminCreate: api.createTour,
  adminUpdate: api.updateTour,
  adminDelete: api.deleteTour,
  adminGetSchedules: api.getAdminTourSchedules,
  adminCreateSchedule: api.createTourSchedule,
  adminUpdateSchedule: api.updateTourSchedule,
  adminDeleteSchedule: api.deleteTourSchedule,
};
